<app-header *ngIf="(deviceType$| async) === 'desktop'"></app-header>
<div class="w-100 bg-white">
    <div class="mobile-header-wrapper position-relative w-100">
        <app-header-mobile
            *ngIf="(deviceType$| async) === 'mobile' || (deviceType$| async) === 'tabletV' || (deviceType$| async) === 'tabletH'"></app-header-mobile>
    </div>
    <div class="container-fluid p-0">
        <app-breadcrumb></app-breadcrumb>
        <app-product-details></app-product-details>
    </div>
    <app-footer></app-footer>
    <ng-container *ngIf="(deviceType$| async) !== 'desktop'">
        <app-fixed-elements [topPosToStartShowing]="thresholdGoToTop"
                            [topPosToStartShowingChat]="thresholdGoToTop"
                            [showChatInitially]="false"></app-fixed-elements>
    </ng-container>
    <app-cookie-consent-dialog></app-cookie-consent-dialog>
    <ng-container *ngIf="(deviceType$| async) === 'desktop'">
        <app-fixed-elements [showChatInitially]="true"></app-fixed-elements>
    </ng-container>

    <app-chat *ngIf="(overlays$ | async).chat"></app-chat>
    <app-menu-mobile
        *ngIf="(mobileMenu$ | async) && ((deviceType$ | async) === 'mobile' || (deviceType$ | async) === 'tabletV' || (deviceType$ | async) === 'tabletH')"></app-menu-mobile>
    <app-menu-mobile-user
        *ngIf="(mobileMenuUser$ |async) && ((deviceType$ | async) === 'mobile' || (deviceType$ | async) === 'tabletV' || (deviceType$ | async) === 'tabletH')"></app-menu-mobile-user>
    <!--<app-login-modal *ngIf="(overlays$ | async).loginModal"></app-login-modal>-->
    <!--<app-register-modal *ngIf="(overlays$ | async).registerModal"></app-register-modal>-->
    <app-added-to-basket *ngIf="(overlays$ | async).addedToBasket"></app-added-to-basket>
    <app-price-band-modal *ngIf="(overlays$ | async).priceBandModal"></app-price-band-modal>
    <app-bespoke-form-modal *ngIf="(overlays$ | async).bespokeForm"></app-bespoke-form-modal>
    <app-colour-variations-modal *ngIf="(overlays$ | async).colourVariationsModal"></app-colour-variations-modal>
    <app-competition-entry *ngIf="(overlays$ | async).enterCompetition"></app-competition-entry>
    <app-max-qty-modal *ngIf="(overlays$ | async).maxQtyWarning"></app-max-qty-modal>

</div>
